import { render, staticRenderFns } from "./Language_info.vue?vue&type=template&id=07294f3c&"
import script from "./Language_info.vue?vue&type=script&lang=js&"
export * from "./Language_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports